import { Key, LogOut, Mail, MessageCircleMore } from "lucide-react"
import Router from "next/router"
import { Button } from "shared-web/components/base/control/Button"

import { useAppSelector } from "app/hooks"

import { selectLastUsedStaffExternalID } from "./authSlice"
import { ErrorMessage } from "./ErrorMessage"
import {
  StepCard,
  StepCardBody,
  StepCardFooter,
  StepCardTitle,
} from "./StepCard"

interface StepSessionTimeoutProps {
  onClickSendTextMessage: (staffExternalId: string) => void
  onClickSendEmail: (staffExternalId: string) => void
  onClickScanKey: (staffExternalId: string) => void
  isSubmitting: boolean
  errorMessage: string | null
}

export function StepSessionTimeout({
  onClickSendTextMessage,
  onClickSendEmail,
  onClickScanKey,
  errorMessage,
}: StepSessionTimeoutProps) {
  const staffExternalId = useAppSelector(selectLastUsedStaffExternalID)

  function sendTextMessage() {
    if (!staffExternalId) return
    onClickSendTextMessage(staffExternalId)
  }

  function sendEmail() {
    if (!staffExternalId) return
    onClickSendEmail(staffExternalId)
  }

  function scanKey() {
    if (!staffExternalId) return
    onClickScanKey(staffExternalId)
  }

  function signOut() {
    Router.push("/auth/sign-in")
  }

  return (
    <StepCard>
      <StepCardTitle>Sign back in</StepCardTitle>
      <StepCardBody className="gap-y-4">
        <ErrorMessage message={errorMessage} />
        <Button
          className="w-full"
          mode="secondary"
          leftIcon={MessageCircleMore}
          onClick={sendTextMessage}
        >
          Sign in using text message
        </Button>
        <Button
          className="w-full"
          mode="secondary"
          leftIcon={Mail}
          onClick={sendEmail}
        >
          Sign in using email
        </Button>
        <Button
          className="w-full"
          mode="secondary"
          leftIcon={Key}
          onClick={scanKey}
        >
          Sign in using key
        </Button>
      </StepCardBody>
      <StepCardFooter className="flex flex-col gap-y-4">
        <Button
          className="w-full"
          mode="ghost"
          leftIcon={LogOut}
          onClick={signOut}
        >
          Sign out
        </Button>
      </StepCardFooter>
    </StepCard>
  )
}
